import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';

import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ClientService } from 'src/app/services/client/client.service';
import { JobService } from 'src/app/services/job/job.service';
import { AssetService } from 'src/app/services/asset/asset.service';

import { JobModel } from 'src/app/models/job.model';
import { AssetModel } from 'src/app/models/asset.model';
import { RemedialModel } from 'src/app/models/remedial.model';
import { ObservationModel } from 'src/app/models/observation.model';
import { AssetPresetStlModel } from 'src/app/models/asset_preset_stl.model';

import { ModalImageUploadComponent } from '../modal-image-upload/modal-image-upload.component';
import { ModalObservationComponent } from '../modal-observation/modal-observation.component';
import { ModalCustomRemedialComponent } from '../modal-custom-remedial/modal-custom-remedial.component';
import { ModalCondmenAssetCertComponent } from '../modal-condmen-asset-cert/modal-condmen-asset-cert.component';
import { ModalReportWhereComponent } from 'src/app/components/modal-report-where/modal-report-where.component';


import { Constants } from 'src/app/constants/constants';
import { formatRelative, parseISO } from 'date-fns';
import * as FileSaver from 'file-saver';
import { register } from 'swiper/element/bundle';
import Swiper from 'swiper';


@Component({
  selector: 'modal-job-asset-details',
  templateUrl: './modal-job-asset-details.component.html',
  styleUrls: ['./modal-job-asset-details.component.scss'],
})
export class ModalJobAssetDetailsComponent implements OnInit {

  selectedJob: JobModel;
  selectedAsset: AssetModel;
  chosenAsset: AssetModel;
  uneditedAsset: AssetModel;
  originalAsset: AssetModel;

  newObservation = new ObservationModel();
  usingLastFields: boolean = false;

  segment: string = 'default';
  presetUid = null;

  loadingImages: boolean = false;

  imagesChanged = false;

  @ViewChild('popover') popover;
  isOpen = false;
  selectedField: any;

  swiperEl = null;
  swiperSlideIndex = 0;

  constructor(private router: Router, public appearanceService: AppearanceService, 
    public userService: UserService, private modalController: ModalController, 
    private alertController: AlertController, public assetService: AssetService, 
    private clientService: ClientService, public jobService: JobService) { }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    register();

    if (!this.selectedJob || !this.chosenAsset)
    {
      this.closeModal();
    }

    this.selectedAsset = JSON.parse(JSON.stringify(this.chosenAsset));

    this.selectedAsset.assetType.allFieldValuePresets = this.jobService.getPresetsForAssetType(this.selectedAsset.assetType.assetTypeUid);

    this.originalAsset = JSON.parse(JSON.stringify(this.selectedAsset));

    this.uneditedAsset = JSON.parse(JSON.stringify(this.selectedAsset));
    this.uneditedAsset.photos = [];
    this.uneditedAsset.assetType.allFieldValuePresets = [];
    this.uneditedAsset.observations = [];

    if (this.userService.isUserLoggedIn()) 
    {
      this.getBase64forImages();
    }
    else 
    {
      this.router.navigateByUrl('/tabs/login');
    }
  }


  ionViewDidEnter()
  {
    this.setUpSwiper();
  }


  openPopover(field, e: Event) 
  {
    this.selectedField = field;
    this.popover.event = e;
    this.isOpen = true;
  }


  async getBase64forImages()
  {
    var that = this;
    this.selectedAsset.photos.forEach(function (item, i, photos) {

      item.loading = true;

      that.assetService.getAssetImage(item.s3Path, that.selectedAsset.jobAssetUid, that.clientService.getClientUid(), that.clientService.getOrganisationUid()).subscribe(response => {

        if (response.Success)
        {
          if (photos[i])
          {
            photos[i].loading = false;
            photos[i].base64 = response.Image;
          }
        }
        else
        {
          that.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {
  
        that.appearanceService.dismissLoading();
        that.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      });     
    });   
  }


  setUpSwiper()
  {
    this.swiperSlideIndex = 0;

    this.swiperEl = new Swiper(document.querySelector<HTMLElement>('.swiper'),
    {
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 500,
        modifier: 1,
        slideShadows: false,
      },
      centeredSlides: true,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });

    var that = this;

    this.swiperEl.on('slideChange', function () {
      that.swiperSlideChanged(this);
    });
  }


  swiperSlideChanged(data)
  {
    this.swiperSlideIndex = data.realIndex;
  }


  wasEditMade(): boolean
  {
      var withoutAssets = {...this.selectedAsset};
      withoutAssets.photos = [];
      withoutAssets.assetType.allFieldValuePresets = [];
      withoutAssets.observations = [];

      return JSON.stringify(this.uneditedAsset) != JSON.stringify(withoutAssets);
  }


  backButtonPressed()
  {
    if (this.wasEditMade())
    {
      this.confirmCancelWithoutSaving();
    }
    else
    {
      this.closeModal();
    }
  }


  async confirmCancelWithoutSaving() 
  {
    const alert = await this.alertController.create({
      header: 'Do you want to save your changes?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            this.closeModal();
          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.saveAsset();

          },
        },
      ],
    });

    await alert.present();
  }


  closeModal(returnData = null)
  {
    if((JSON.stringify(this.originalAsset.observations) != JSON.stringify(this.selectedAsset.observations)))
    {
      returnData = { reload: true };
    }

    if (this.imagesChanged)
    {
      returnData = { reload: true };
    }
    
    this.modalController.dismiss(returnData, null, 'AssetDetailsModal');
  }


  async openCreateNewObservationModal() 
  {
    const modal = await this.modalController.create({
      component: ModalObservationComponent,
      backdropDismiss: true,
      id: 'RemedialModal',
      cssClass: 'full-screen-modal',
      componentProps: { 
        createNewObservation: true, 
        isEditing: false,
        selectedAsset: this.selectedAsset
      }
    });

    modal.onDidDismiss().then((response: any) => {

      if (response)
      {
        if (response.data)
        {
          if (response.data.observation)
          {
            this.createNewObservation(response.data.observation);
          }
        }
      }

    })

    return await modal.present();
  }


  createNewObservation(observation)
  {
    var payload = {
      newObservation: observation,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAsset.uid,
      jobAssetUid: this.selectedAsset.jobAssetUid,
      jobUid: this.selectedJob.jobUid
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addObservationToAsset(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.selectedAsset.observations = new Array<ObservationModel>();

          for (var x = 0; x < response.AssetObservations.length; x++)
          {
              var entry = response.AssetObservations[x];

              var newObs = new ObservationModel();

              newObs.uid                                = Number(entry.observationUid);
              newObs.ref                                = entry.observationRef;
              newObs.observationInfo                    = entry.observationInfo;
              newObs.conditionCode                      = entry.conditionCode;
              newObs.observedDateTime                   = entry.observedDateTime;
              newObs.chosenRemedials                    = new Array<RemedialModel>();
              newObs.customRemedials                    = new Array<RemedialModel>();
              newObs.presetStlRemedialUids              = new Array<any>();  // @Fil Can be removed once updated to use model below
              observation.currentStlPresets             = new Array<AssetPresetStlModel>(); 
              newObs.loggedByUser                       = entry.loggedByUser;
              newObs.repairedOnJobUid                   = entry.repairedOnJobUid;
              newObs.recommendedOnJobUid                = entry.recommendedOnJobUid;
              newObs.repairedByUser                     = entry.repairedByUser;
              newObs.recommendedByUser                  = entry.recommendedByUser;
              newObs.repairNotes                        = entry.repairNotes;
              newObs.condemnAssetReuseParts             = entry.condemnAssetReuseParts;
              newObs.condemnAssetReusePartsText         = entry.condemnAssetReusePartsText;
              newObs.condemnAssetIsolated               = entry.condemnAssetIsolated;
              newObs.condemnFuseRemoved                 = entry.condemnFuseRemoved;
              newObs.condemnAssetSufficientLighting     = entry.condemnAssetSufficientLighting;
              newObs.condemnAssetDangerousPosition      = entry.condemnAssetDangerousPosition;
              newObs.condemnAssetDangerousPositionText  = entry.condemnAssetDangerousPositionText;
              newObs.observedDateTimeReadable           = entry.observedDateTimeReadable;
              newObs.recommendedDateTimeReadable        = entry.recommendedDateTimeReadable;
              newObs.repairedDateTimeReadable           = entry.repairedDateTimeReadable;
              
              newObs.repairedDateTime     = null;
              newObs.recommendedDateTime  = null;
              newObs.powerIssue           = null;

              if (entry.powerIssue)
              {
                newObs.powerIssue = entry.powerIssue;
              }

              if (entry.repairedDateTime) 
              {
                newObs.repairedDateTime = entry.repairedDateTime;
              }

              if (entry.recommendedDateTime) 
              {
                newObs.recommendedDateTime = entry.recommendedDateTime;
              }
              
              for (var y = 0; y < entry.remedials.length; y++)
              {
                var newRemedial = new RemedialModel();

                newRemedial.assetObservationRemedialUid   = Number(entry.remedials[y].assetObservationRemedialUid);
                newRemedial.quantity                      = Number(entry.remedials[y].stlQuantity);
                newRemedial.stlCode                       = entry.remedials[y].stlCode;
                newRemedial.name                          = entry.remedials[y].remedialName;
                newRemedial.remedialUid                   = Number(entry.remedials[y].remedialUid);

                newObs.chosenRemedials.push(newRemedial)
              }

              for (var z = 0; z < entry.customRemedials.length; z++)
              {
                var newCustomRemedial = new RemedialModel();
  
                newCustomRemedial.assetObservationCustomRemedialUid   = Number(entry.customRemedials[z].assetObservationCustomRemedialUid);
                newCustomRemedial.stlCode                             = entry.customRemedials[z].customRemedialCode;
                newCustomRemedial.name                                = entry.customRemedials[z].customRemedialName;
                newCustomRemedial.charge                              = entry.customRemedials[z].customRemedialCharge;
  
                newObs.customRemedials.push(newCustomRemedial)
              }

              for (var z = 0; z < entry.stlPresets.length; z++)
              {
                // @Fil Can be removed once updated to use model below
                newObs.presetStlRemedialUids.push(entry.stlPresets[z].stlPresetUid);

                var newStlPreset  = new AssetPresetStlModel();
                newStlPreset.uid  = entry.stlPresets[z].stlPresetUid;
                newStlPreset.name = entry.stlPresets[z].stlPresetName;
                
                newObs.currentStlPresets.push(newStlPreset);
              }   

              this.selectedAsset.observations.push(newObs);
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async deleteObservationOrRepair(obs, index) 
  {
    var type = obs.repairedOnJobUid ? 'Repair' : 'Observation';
    var typeTwo = obs.repairedOnJobUid ? 'undo' : 'delete';

    const alert = await this.alertController.create({
      header: 'Are you sure you want to ' + typeTwo + ' this ' + type + '?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            if (type == 'Repair')
            {
              this.confirmedUndoRepair(obs, null);
            }
            else
            {
              this.confirmedRemoveObservation(obs, index);
            }

          },
        },
      ],
    });

    await alert.present();
  }


  confirmedRemoveObservation(obs, index)
  {
    var payload = {
      observation: obs,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetName: this.selectedAsset.name
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.deleteObservationFromAsset(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var foundIndex = null;

          for (var i = 0; i < this.selectedAsset.observations.length; i++)
          {
            if (this.selectedAsset.observations[i].uid == obs.uid)
            {
              foundIndex = i;
              break;
            }
          }

          if (foundIndex != null)
          {
            this.selectedAsset.observations.splice(foundIndex, 1);
          }

          if (!this.selectedAsset.observations.length)
          {
            this.selectedAsset.observations = new Array<ObservationModel>();
          }

          this.appearanceService.presentToast("Observation deleted.", Constants.TOAST_SUCCESS);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
    
      },
      err => 
      {
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast("Failed to remove Observation.", Constants.TOAST_ERROR);
      });
    });
  }


  async deleteAssetFromJob() 
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to remove this asset from the job?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmedDeleteAssetFromJob();

          },
        },
      ],
    });

    await alert.present();
  }


  downloadPhoto(index)
  {
    // Split the base64 string in data and contentType
    var block = this.selectedAsset.photos[index].base64.split(";");
    // Get the content type
    var dataType = block[0].split(":")[1];

    // get the real base64 content of the file
    var realData = block[1].split(",")[1];// In this case "JVBERi0xLjcKCjE...."

    var blob = this.b64toBlob(realData, dataType);

    var fileName =  this.selectedAsset.name + "_" + this.selectedAsset.photos[index].fileName + "." + this.selectedAsset.photos[index].fileType;
    FileSaver.saveAs(blob, fileName);
    
  }


  b64toBlob(b64Data, contentType, sliceSize = null) 
  {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) 
    {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);

        for (var i = 0; i < slice.length; i++) 
        {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: contentType});

    return blob;
  }


  async deletePhoto(index)
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to delete this photo?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmedDeletePhoto(index);

          },
        },
      ],
    });

    await alert.present();
  }


  confirmedDeleteAssetFromJob()
  {
    var payload = {
      jobAssetUid: this.selectedAsset.jobAssetUid,
      jobUid: this.selectedJob.jobUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid()
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.removeAssetFromJob(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.appearanceService.presentToast("Asset removed.", Constants.TOAST_SUCCESS);
  
          var returnData = { reload: true };
          this.modalController.dismiss(returnData, null, 'AssetDetailsModal');
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
    
      },
      err => 
      {
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast("Failed to remove Asset.", Constants.TOAST_ERROR);
      });
    });
  }


  confirmedDeletePhoto(index)
  {
    var payload = {
      assetFileUid: this.selectedAsset.photos[index].uid,
      jobAssetUid: this.selectedAsset.jobAssetUid,
      jobUid: this.selectedJob.jobUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid()
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.deleteAssetPhoto(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.selectedAsset.photos.splice(index, 1);
          this.imagesChanged = true;

          this.appearanceService.presentToast("Image deleted.", Constants.TOAST_SUCCESS);
          this.swiperEl.removeSlide(index);   
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => 
      {
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast("Failed to delete Image.", Constants.TOAST_ERROR);
      });
    });
  }


  async uploadPhoto() 
  {
    const modal = await this.modalController.create({
      component: ModalImageUploadComponent,
      backdropDismiss: false,
      componentProps: { 
        assetUid: this.selectedAsset.jobAssetUid,
        jobUid: this.selectedJob.jobUid,
        uploadUrl: "asset/image/upload",
        resource: 'asset'
      },
      cssClass: 'ninety8-screen-modal',
      id: 'ImageUploadModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response.data)
      {
        if (response.data.addedFile)
        {
          this.imagesChanged = true;
          this.selectedAsset.photos.push(response.data.addedFile);
        }
      }
    })

    return await modal.present();
  }


  saveAsset()
  {
    var payload = {
      jobAssetUid: this.selectedAsset.jobAssetUid,
      jobUid: this.selectedJob.jobUid,
      asset: this.selectedAsset,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid()
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.updateJobAssetDetails(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.appearanceService.presentToast("Asset updated.", Constants.TOAST_SUCCESS);
          
          this.assetService.saveLastAssetValues(this.selectedAsset.fields);

          var returnData = { reload: true };
          this.modalController.dismiss(returnData, null, 'AssetDetailsModal');

        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
    
      },
      err => 
      {
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast("Failed to update Asset.", Constants.TOAST_ERROR);
      });
    });
  }


  setAllLim()
  {
    this.usingLastFields = false;

    for (var i = 0; i < this.selectedAsset.fields.length; i++)
    {
      var field = this.selectedAsset.fields[i];
      field.value = "lim";
    }
  }


  setPreset(preset)
  {
    this.usingLastFields = false;

    if (preset)
    {
      this.presetUid = preset.uid;

      for (var x = 0; x < preset.defaultValues.length; x++)
      {
        var defaultValue = preset.defaultValues[x];
        
        for (var i = 0; i < this.selectedAsset.fields.length; i++)
        {
          var field = this.selectedAsset.fields[i];

          if (field.uid == defaultValue.uid)
          {
            field.value =  defaultValue.val;
          }
        }

      }
    }
    else
    {
      this.presetUid = null;

      for (var i = 0; i < this.selectedAsset.fields.length; i++)
        {
          var field = this.selectedAsset.fields[i];
          field.value = "";
        }
    }
  }


  setLastAssetFields()
  {
    var lastFields = this.assetService.getLastAssetFields();

    this.presetUid = null;

    for (var x = 0; x < lastFields.length; x++)
    {
      var lastField = lastFields[x];
      
      for (var i = 0; i < this.selectedAsset.fields.length; i++)
      {
        var field = this.selectedAsset.fields[i];

        if (field.uid == lastField.uid)
        {
          field.value = lastField.value;
          break;
        }
      }
    }

    this.usingLastFields = true;
  }


  getDaysAgo(dateTime)
  {
    return formatRelative(parseISO(dateTime), new Date());
  }


  async askToDeleteObservationStl(observation, slidingRow, remedial)
  {
    var deleteAll = false;
    
    if(remedial.quantity > 1)
    {
      const alert = await this.alertController.create({
        header: 'Would you like to delete all or just one of ' + remedial.name + '?',
        buttons: [
          {
            text: 'Just One',
            role: 'confirm',
            handler: () => {
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
          {
            text: 'All',
            role: 'confirm',
            handler: (data) => {
              deleteAll = true;
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              slidingRow.close();
            },
          },
        ],
      });
  
      await alert.present();
    }
    else
    {
      const alert = await this.alertController.create({
        header: 'Are you sure you want to delete ' + remedial.name + '?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              slidingRow.close();
            },
          },
          {
            text: 'Yes',
            role: 'confirm',
            handler: (data) => {
              deleteAll = true;
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
        ],
      });
  
      await alert.present();
    }

  }


  confirmDeleteRemedialStl(observation, slidingRow, remedialUid, deleteAll)
  {
    var payload = {
      observationUid: observation.uid,
      remedialUid: remedialUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAsset.uid,
      deleteAll: deleteAll
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeRemedialStlFromObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();
        slidingRow.close();

        if (response.Success)
        {
          observation.chosenRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.Observations.length; i++)
          {
            var newRemedial = new RemedialModel();

            newRemedial.assetObservationRemedialUid   = Number(response.Observations[i].assetObservationRemedialUid);
            newRemedial.quantity                      = Number(response.Observations[i].stlQuantity);
            newRemedial.stlCode                       = response.Observations[i].stlCode;
            newRemedial.name                          = response.Observations[i].remedialName;
            newRemedial.remedialUid                   = Number(response.Observations[i].remedialUid);

            observation.chosenRemedials.push(newRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        slidingRow.close();
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async duplicateLastObservation()
  {
    let lastObs = this.assetService.getLastObservation();

    const modal = await this.modalController.create({
      component: ModalObservationComponent,
      backdropDismiss: false,
      componentProps: { 
        createNewObservation: 
        false, 
        isEditing: false, 
        originalObservation: lastObs, 
        isDuplicating: true,
        selectedAsset: this.selectedAsset
      },
      cssClass: 'full-screen-modal',
      id: 'RemedialModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response)
      {
        if (response.data)
        {
          if (response.data.observation)
          {
            this.createNewObservation(response.data.observation);
          }
        }
      }
    })

    return await modal.present();
  }


  async createAssetAlertFromJobAssetDetails()
  {
    const alert = await this.alertController.create({
      header: 'Please enter an alert note',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
        
          },
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: (data) => {
            
            if (data.name.length > 0)
            {
              this.addAssetAlertFromJobAssetDetails(data.name);
            }
          },
        },
      ],
      inputs: [
        {
          placeholder: 'Alert note',
          name: 'name',
          attributes: {
            maxlength: 255,
          },
        },
      ],
    });

    await alert.present();
  }


  addAssetAlertFromJobAssetDetails(note)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      note: note,
      jobUid: null,
      assetUid: this.selectedAsset.uid,
      locationUid: null
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.createJobAlert(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.appearanceService.presentToast("Alert Created", Constants.TOAST_SUCCESS);

          this.appearanceService.triggerEvent('badgeCounters:update', { });
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async addCustomRemedial(observation)
  {
    const modal = await this.modalController.create({
      component: ModalCustomRemedialComponent,
      backdropDismiss: false,
      componentProps: {  },
      id: 'CustomRemedialModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response.data)
      {
        if(response.data.customRemedial)
        {
          this.confirmAddCustomRemedial(observation, response.data.customRemedial);
        }
      }
    })

    return await modal.present();
  }


  confirmAddCustomRemedial(observation, customRemedial)
  {
    var payload = {
      observation: observation,
      newCustomRemedial: customRemedial,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAsset.uid
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addCustomRemedialStlToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          observation.customRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.ObservationCustomRemedials.length; i++)
          {
            var newCustomRemedial = new RemedialModel();

            newCustomRemedial.assetObservationCustomRemedialUid = Number(response.ObservationCustomRemedials[i].assetObservationCustomRemedialUid);
            newCustomRemedial.stlCode                           = response.ObservationCustomRemedials[i].customRemedialCode;
            newCustomRemedial.name                              = response.ObservationCustomRemedials[i].customRemedialName;
            newCustomRemedial.charge                            = response.ObservationCustomRemedials[i].customRemedialCharge;

            observation.customRemedials.push(newCustomRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async askToDeleteObservationCustomRemedial(observation, slidingRow, customRemedial)
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to delete (' + customRemedial.stlCode + ") - " + customRemedial.name + '?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            slidingRow.close();
          },
        },
        {
          text: 'Yes', 
          role: 'confirm',
          handler: (data) => {
            
            this.confirmDeleteCustomRemedialStl(observation, slidingRow, customRemedial.assetObservationCustomRemedialUid);

          },
        },
      ],
    });

    await alert.present();
  }


  confirmDeleteCustomRemedialStl(observation, slidingRow, assetObservationCustomRemedialUid)
  {
    var payload = {
      observationUid: observation.uid,
      assetObservationCustomRemedialUid: assetObservationCustomRemedialUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAsset.uid
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeCustomRemedialStlFromObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();
        slidingRow.close();

        if (response.Success)
        {
          observation.customRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.Observations.length; i++)
          {
            var newCustomRemedial = new RemedialModel();

            newCustomRemedial.assetObservationCustomRemedialUid   = Number(response.Observations[i].assetObservationCustomRemedialUid);
            newCustomRemedial.stlCode                             = response.Observations[i].customRemedialCode;
            newCustomRemedial.name                                = response.Observations[i].customRemedialName;
            newCustomRemedial.charge                              = response.Observations[i].customRemedialCharge;

            observation.customRemedials.push(newCustomRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        slidingRow.close();
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async editObservationModal(observation)
  {
    const modal = await this.modalController.create({
      component: ModalObservationComponent,
      backdropDismiss: false,
      componentProps: { createNewObservation: false, isEditing: true, originalObservation: observation, selectedAsset: this.selectedAsset },
      cssClass: 'full-screen-modal',
      id: 'RemedialModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response)
      {
        if (response.data)
        {
          if (response.data.updateObservation)
          {
            var payload = {
              observationUid: observation.uid,
              observationInfo: response.data.updatedInfo,
              updatedConditionCode: response.data.updatedConditionCode,
              newStls: response.data.newStls,
              changedStls: response.data.changedStls,
              clientUid: this.clientService.getClientUid(),
              organisationUid: this.clientService.getOrganisationUid(),
              assetUid: this.selectedAsset.uid,
              newStlPresetUids: response.data.newStlPresetUids,
              deletedStlPresetUids: response.data.deletedStlPresetUids,
              condemnData: response.data.condemnData
            }

            this.confirmObservationEdit(observation, payload);
          }
        }
      }
    })

    return await modal.present();
  }


  confirmObservationEdit(observation, payload)
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.updateObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          observation.chosenRemedials                    = new Array<RemedialModel>();
          observation.presetStlRemedialUids              = new Array<any>();
          observation.currentStlPresets                  = new Array<AssetPresetStlModel>(); 
          observation.observationInfo                    = response.Observation.observationInfo;
          observation.conditionCode                      = response.Observation.conditionCode;
          observation.condemnAssetReuseParts             = response.Observation.condemnAssetReuseParts;
          observation.condemnAssetReusePartsText         = response.Observation.condemnAssetReusePartsText;
          observation.condemnAssetIsolated               = response.Observation.condemnAssetIsolated;
          observation.condemnFuseRemoved                 = response.Observation.condemnFuseRemoved;
          observation.condemnAssetSufficientLighting     = response.Observation.condemnAssetSufficientLighting;
          observation.condemnAssetDangerousPosition      = response.Observation.condemnAssetDangerousPosition;
          observation.condemnAssetDangerousPositionText  = response.Observation.condemnAssetDangerousPositionText;

          for (var i = 0; i < response.Observation.stls.length; i++)
          {
            var newRemedial = new RemedialModel();

            newRemedial.assetObservationRemedialUid   = Number(response.Observation.stls[i].assetObservationRemedialUid);
            newRemedial.quantity                      = Number(response.Observation.stls[i].stlQuantity);
            newRemedial.stlCode                       = response.Observation.stls[i].stlCode;
            newRemedial.name                          = response.Observation.stls[i].remedialName;
            newRemedial.remedialUid                   = Number(response.Observation.stls[i].remedialUid);

            observation.chosenRemedials.push(newRemedial)
          }

          for (var z = 0; z < response.Observation.stlPresets.length; z++)
          {
            // @Fil Can be removed once updated to use model below
            observation.presetStlRemedialUids.push(response.Observation.stlPresets[z].stlPresetUid);

            var newStlPreset  = new AssetPresetStlModel();
            newStlPreset.uid  = response.Observation.stlPresets[z].stlPresetUid;
            newStlPreset.name = response.Observation.stlPresets[z].stlPresetName;
            
            observation.currentStlPresets.push(newStlPreset);
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async deletePowerAlert(observation) 
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to remove this power alert?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            var payload = {
              observationUid: observation.uid,
              clientUid: this.clientService.getClientUid(),
              organisationUid: this.clientService.getOrganisationUid()
            }

            this.appearanceService.showLoading("Please wait...").then(() => {

              this.assetService.removePowerIssueFromObservation(payload).subscribe(response => {
            
                this.appearanceService.dismissLoading();
        
                if (response.Success)
                {
                  observation.powerIssue = false;
                }
                else
                {
                  this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
                }
              },
              err => {
        
                this.appearanceService.dismissLoading();
                this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
        
              });
            });
          },
        },
      ]
    });

    await alert.present();
  }


  async changeReportedUser(isRepair, obs, isRecommended)
  {
    const modal = await this.modalController.create({
      component: ModalReportWhereComponent,
      backdropDismiss: false,
      componentProps: { selectedList: [], whereCriteria: "users" , limit: 1},
      id: 'ReportWhereModal'
    });

    modal.onDidDismiss().then(async (response) => {

      if (response.data)
      {
        if (response.data.selected)
        {          
          var payload = {
            isRepair: isRepair,
            isRecommended: isRecommended,
            observationUid: obs.uid,
            newUserUid: response.data.selected[0].uid,
            newUserName: response.data.selected[0].name
          }

          this.appearanceService.showLoading("Please wait...").then(() => {

            this.assetService.changeNameOnObservation(payload).subscribe(response => {
          
              this.appearanceService.dismissLoading();
      
              if (response.Success)
              {
                if (isRepair)
                {
                  obs.repairedByUser = payload.newUserName;
                }
                else if (isRecommended)
                {
                  obs.recommendedByUser = payload.newUserName;
                }
                else
                {
                  obs.loggedByUser = payload.newUserName;
                }
              }
              else
              {
                this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
              }
            },
            err => {
      
              this.appearanceService.dismissLoading();
              this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      
            });
          });

        }
      }
    })

    return await modal.present();
  }


  async markObservationAsRepaired(obs)
  {  
    const modal = await this.modalController.create({
      component: ModalReportWhereComponent,
      backdropDismiss: false,
      componentProps: { selectedList: [], whereCriteria: "users" , limit: 1},
      id: 'ReportWhereModal'
    });

    modal.onDidDismiss().then(async (response) => {

      if (response.data)
      {
        if (response.data.selected)
        {          

          const alert = await this.alertController.create({
            header: 'Please enter any repair notes',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
      
                },
              },
              {
                text: 'Save',
                role: 'confirm',
                handler: (data) => {
                  
                  var payload = {
                    clientUid: this.clientService.getClientUid(),
                    organisationUid: this.clientService.getOrganisationUid(),
                    observationUid: obs.uid,
                    jobUid: this.selectedJob.jobUid,
                    jobAssetUid: this.selectedAsset.jobAssetUid,
                    repairNotes: data[0],
                    repairedByUserUid: response.data.selected[0].uid,
                    repairedByUserName: response.data.selected[0].name
                  };
      
                  this.confirmedMarkObservationAsRepaired(payload, obs);
                },
              },
            ],
            inputs: [
              {
                placeholder: 'Repair Notes',
              },
            ],
          });
      
          await alert.present();
        }
      }
    })

    return await modal.present();
  }



  confirmedMarkObservationAsRepaired(payload, obs)
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.markObservationAsRepaired(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          obs.repairedOnJobUid  = payload.jobUid;
          obs.repairedByUser    = payload.repairedByUserName;
          obs.repairNotes       = payload.repairNotes;
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async askToDeleteRepair(obs, slidingRow)
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to remove this repair?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            slidingRow.close();
          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmedUndoRepair(obs, slidingRow);
          },
        },
      ],
    });

    await alert.present();
  }


  confirmedUndoRepair(obs, slidingRow)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      observationUid: obs.uid
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeRepairFromObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          obs.repairedDateTime = null;
          obs.repairedOnJobUid = null;
          obs.repairedByUser = null;
          obs.repairNotes = null;
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  markObservationRecommended(obs, i)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      observationUid: obs.uid,
      jobUid: this.selectedJob.jobUid
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addRecommendationToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          obs.recommendedOnJobUid  = this.selectedJob.jobUid;
          obs.recommendedByUser    = this.userService.getUserName();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  markObservationNotRecommended(obs, i)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      observationUid: obs.uid
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeRecommendationToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          obs.recommendedDateTime = null;
          obs.recommendedOnJobUid = null;
          obs.recommndedByUser = null;
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async addPowerIssueToObservation(observation)
  {
    const alert = await this.alertController.create({
      header: 'Who is responsible for this power issue?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Save',
          role: 'confirm',
          handler: (data) => {
            
            if (data == null)
            {
              this.appearanceService.presentToast("Please make a selection", Constants.TOAST_INFO);
              this.addPowerIssueToObservation(observation);
            }
            else
            {
              this.confirmedAddPowerIssueToObservation(data, observation);
            }
          },
        },
      ],
      inputs: [
        {
          label: 'Private',
          type: 'radio',
          value: '1',
        },
        {
          label: 'D.N.O.',
          type: 'radio',
          value: '2',
        },
      ],
    });

    await alert.present();
  }


  confirmedAddPowerIssueToObservation(choice, observation)
  {
    var payload = {
      observationUid: observation.uid,
      powerIssue: choice,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addPowerIssueToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          observation.powerIssue = choice;
          this.appearanceService.triggerEvent('badgeCounters:update', { });    
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }

  async generateCondemnationCert(observation)
  {
    const modal = await this.modalController.create({
      component: ModalCondmenAssetCertComponent,
      backdropDismiss: false,
      cssClass: 'full-screen-modal',
      componentProps: { selectedJob: this.selectedJob, selectedAsset: this.selectedAsset, observation: observation },
      id: 'CondemnCertModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response.data)
      {

      }
    })

    return await modal.present();
  }


  getObservationClass(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'condemned-card';
    }
    else if (observation.repairedOnJobUid)
    {
      return 'repaired-card';
    }
    else if (observation.recommendedOnJobUid)
    {
      return 'recommended-card';
    }

    return 'obs-card';
  }


  getObservationCardTitle(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'Condemned';
    }
    else if (observation.recommendedOnJobUid && !observation.repairedOnJobUid)
    {
      return "Recommended";
    }
    else if (observation.repairedOnJobUid)
    {
      return "Repaired";
    }

    return observation.conditionCode;
  }


  getObservationCardTitleColor(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'danger';
    }
    else if (observation.recommendedOnJobUid && !observation.repairedOnJobUid)
    {
      return "warning";
    }
    else if (observation.repairedOnJobUid)
    {
      return "success";
    }

    return ""
  }


  canWeRecommenedObservation(observation: ObservationModel)
  {
    if (observation.recommendedOnJobUid || observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    return true;
  }


  canWeUnrecommenedObservation(observation: ObservationModel)
  {
    if (observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    if (observation.recommendedOnJobUid)
    {
      return true;
    }

    return false;
  }


  canWeRepairObservation(observation: ObservationModel)
  {
    if (observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    return true;
  }
}